import { events } from '@/utils/segment';

const dispatchToasterEvent = (elementAction: string, elementValue: string): void => {
  events.track('content_display_interacted', {
    element_name: 'toast_active_lead_review',
    element_value: elementValue,
    element_action: elementAction,
    category: 'behavior',
    journey: 'lead_creation',
  });
};

export { dispatchToasterEvent };
